/**
 * Prices Service
 * Handles price list operations including Priority sync
 */
import { callFunction } from '../firebase/functions.js'
import logger from './logger.js'

const log = logger.createScoped('PricesService')

// 10 minutes timeout to match Cloud Function's 540s limit
const PRICES_PULL_TIMEOUT = 600000

/**
 * Pull price lists from Priority ERP and sync to Firestore
 * Calls the priorityPullPriceLists callable function
 * @returns {Promise<Object>} Result with priceListsFound, priceListsProcessed, itemsUpserted, failedCount, durationMs, errors
 */
export async function pullPriceListsFromPriority() {
  log.info('Starting Priority price lists pull')

  try {
    const result = await callFunction(
      'priorityPullPriceLists',
      {},
      { timeout: PRICES_PULL_TIMEOUT }
    )

    log.info('Priority price lists pull completed', {
      priceListsFound: result.priceListsFound,
      priceListsProcessed: result.priceListsProcessed,
      itemsUpserted: result.itemsUpserted,
      failedCount: result.failedCount,
      durationMs: result.durationMs,
    })

    return result
  } catch (error) {
    log.error('Priority price lists pull failed', error)
    throw error
  }
}

/**
 * Pull amount discounts from Priority ERP and sync to Firestore
 * Calls the priorityPullAmountDiscounts callable function
 * @returns {Promise<Object>} Result with fetchedCount, assortmentsCount, itemDocsWrittenCount, etc.
 */
export async function pullAmountDiscountsFromPriority() {
  log.info('Starting Priority amount discounts pull')

  try {
    const result = await callFunction(
      'priorityPullAmountDiscounts',
      {},
      { timeout: PRICES_PULL_TIMEOUT }
    )

    log.info('Priority amount discounts pull completed', {
      fetchedCount: result.fetchedCount,
      assortmentsCount: result.assortmentsCount,
      itemDocsWrittenCount: result.itemDocsWrittenCount,
      failedCount: result.failedCount,
      durationMs: result.durationMs,
    })

    return result
  } catch (error) {
    log.error('Priority amount discounts pull failed', error)
    throw error
  }
}
